import AuthorizedPatientsWithoutVisitsPage from "./AuthorizedPatientsWithoutVisitsPage";

export default function AuthorizedPatientsWithoutVisitsRoute() {
  return (
    <>
      <AuthorizedPatientsWithoutVisitsPage />
    </>
  );
}
